<div class="cmps-cdk-d-flex">
    <ng-container
        *ngFor="
            let data of distributionData;
            let isFirst = first;
            let isLast = last
        "
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-column"
            [style.width.%]="data.percentageWidth"
            [cmpsTooltipTrigger]="distributionTooltip"
            [cmpsTooltipTriggerCustomTemplate]="true"
            *ngIf="data.percentageWidth > 0"
        >
            <div
                class="cmps-cdk-min-h-15p {{ data.classList }}"
                [class.cmps-wp-progress-bar--first-section]="isFirst"
                [class.cmps-wp-progress-bar--last-section]="isLast"
            ></div>
            <div
                class="cmps-cdk-text-center cmps-cdk-font-bold cmps-cdk-color-black cmps-cdk-font-size-12p"
            >
                {{
                    data.percentageWidth < _MIN_PERCENTAGE
                        ? '...'
                        : (data.percentage | cmpsWpPercent)
                }}
            </div>
        </div>
    </ng-container>
    <ng-template #distributionTooltip>
        <cmps-dialog>
            <cmps-dialog-body
                class="cmps-cdk-m-0dot25 cmps-cdk-align-items-end cmps-wp-progress-bar--tooltip"
            >
                <div
                    class="cmps-cdk-d-flex cmps-cdk-font-size-14p cmps-cdk-font-bold"
                >
                    <div class="cmps-cdk-flex-40 cmps-cdk-d-flex">
                        {{ _i18n._11202_STATE | translate }}
                    </div>
                    <div
                        class="cmps-cdk-flex-30 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                    >
                        {{ _i18n._10089_PERCENTAGE | translate }}
                    </div>
                    <div
                        class="cmps-cdk-flex-30 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                    >
                        {{ _i18n._10090_NUMBER | translate }}
                    </div>
                </div>
                <ng-container *ngFor="let tooltip of distributionTooltipData">
                    <div class="cmps-cdk-d-flex cmps-cdk-mt-0dot5">
                        <div
                            class="cmps-cdk-flex-40 cmps-cdk-d-flex cmps-cdk-align-items-center justify-content-between"
                        >
                            <div class="">{{ tooltip.title | translate }}</div>
                            <div
                                class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px {{
                                    tooltip.classList
                                }}"
                            ></div>
                        </div>
                        <div
                            class="cmps-cdk-flex-30 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                        >
                            {{ tooltip.percentage | cmpsWpPercent }}
                        </div>
                        <div
                            class="cmps-cdk-flex-30 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                        >
                            {{ tooltip.number }}
                        </div>
                    </div>
                </ng-container>
            </cmps-dialog-body>
        </cmps-dialog>
    </ng-template>
</div>
